import React from "react";

export default function ImplementationDegradation(props) {
    return (
        <div>
            <div
                style={{
                    backgroundColor: " rgb(255,183,233)",
                    background:
                        "linear-gradient(180deg, rgba(255,183,233,1) 0%, rgba(255,129,232,1) 47%, rgba(147,0,255,1) 100%)",
                    minHeight: "100vh",
                }}>
                <div
                    className="fixed bottom-0 w-full py-8 px-4 flex justify-around text-2xl text-white cano"
                    style={{backgroundColor: "rgba(87,174,255,.7)"}}>
                    <a href="#detection_and_quantification">Overview</a>
                    <a href="#biological_receptor">Biologicar Receptor hERa</a>
                    <a href="#immobilization_title">Immobilization</a>
                    <a href="#software_title">Software</a>
                    <a href="#3d_printed_title">3D Printed Case</a>
                </div>
                <div className="hero">
                    <img
                        src="https://static.igem.wiki/teams/4260/wiki/imagen/project/degradation-model/fondos-de-degradacion/moneda-molecula.png"
                        alt="Biosensor coin"
                        className="w-full"
                    />
                    <div className="w-full flex justify-around items-center">
                        <div onClick={props.switchPage} className="p-8 clickable">
                            <svg
                                width="76.7"
                                height="135.2"
                                viewBox="0 0 59 104"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M55 4L7 52L55 100" stroke="#233876" stroke-width="9"/>
                            </svg>
                        </div>
                        <div className="flex flex-col items-center">
                            <h2 className="text-3xl cano text-blue-900"> IMPLEMENTATION </h2>
                            <h1 className="text-8xl cano text-blue-900"> DEGRADATION</h1>
                        </div>
                        <div onClick={props.switchPage} className="p-8 clickable">
                            <svg
                                width="76.7"
                                height="135.2"
                                viewBox="0 0 59 104"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M4 100L52 52L4 4" stroke="#233876" stroke-width="9"/>
                            </svg>
                        </div>
                    </div>
                </div>
                <div className="h-full w-full">
                    <div className="p-10 max-w-5xl m-auto pt-20 text-white">
                        <h1 className="text-6xl text-center text-white font-bold">
                            Degradation
                        </h1>
                        <p className="p">
                            <br/>
                            Our end goal is to have a beneficial impact on the problem of EDCs, so
                            based on the conditions in which farmers work we have designed an end
                            product.Here we have the final product: a small, simple to use packing
                            with our immobilized laccase to help curve the problem of EDCs.During
                            our investigation, we found that in Mexico the principal way of
                            irritigatings crops is through gravity or flood irrigation, with a
                            National average of 74.9% [1].Irrigation by flooding is done with
                            channels or furrows throughout the planting area, which are connected
                            to a pond, river, well or any other water body.[2]In Mexico most of
                            the water used for irrigation is not treated, around 54% [3], and as it
                            was previously established this water gets contaminated from several
                            domestic and industrial sources, for example: treatment plants,
                            effluents from hospitals, chemicals used in agricultural activities
                            and livestock, septic tanks and others [3]. All of these are sources of
                            EDCs leading to the water having the presence of these substances.With
                            this information, a great moment of action is working on the water
                            farmers use to irrigate their crops, to reduce the amount of EDCs
                            present in the food we consume, as well to avoid further contamination
                            of the soil and groundwaters.
                            <br/>
                            <br/>
                            From the information we gathered from our stakeholders and our
                            research; agriculture in Mexico represents an important work force
                            with 5.5 million workers, but they also represent around 21.6% of the
                            poorest people in the country.[4]With this in mind, any implementation
                            has to be low in cost and also considering the principal way of
                            irrigation (flood irrigation); it is also necessary to be simple in
                            design to propose a solution.
                            <br/>
                            Arriving at that solution wasn't an easy task. During our design
                            stages we went through a lot of different options and prototypes;
                            always adapting it to the needs and reality of our stakeholders,
                            because in some cases, even a water pump (which is a common hardware
                            on agriculture) can be inaccessible for mexican farmers.When we
                            adopted laccase to be our principal agent for the solution we began to
                            think about how to implement it outside the laboratory.The first
                            implementation was related to a filtering membrane with the laccases.
                            After improvements were done to the laccase by immobilizing it on
                            zeolites, we chose a new irrigation system on sprinkler systems with a
                            hard case that had the immobilized enzymes with zeolites.This proposal
                            was abandoned because of the necessity of more time for degradation
                            and because an irrigation system like sprinklers is far from the
                            reality that farmers use in Mexico.To provide the necessary conditions
                            for the laccase to work the third design was related to a mixing tank
                            to provide a more efficient enzymatic activity, but this
                            implementation was also far from the reality and possibilities of
                            mexican farmers because of the high costs this hardware would require.
                            Finally we arrive at our current implementation, a small packing that
                            contains the immobilized enzyme as powder.This provides the simplest
                            use for farmers and cheapest.
                            <br/>
                            <img
                                src="https://static.igem.wiki/teams/4260/wiki/propoimplesinfondo.png"
                                alt="propoimplesinfondo"
                                className="figure"
                            />
                            <p className="figure_desc">
                                <strong>Fig. 2 </strong>History of proposed implementations by TecCEM degradation team
                            </p>
                            <p className="p"></p>
                            <br/>
                            With our project, agriculture related personnel will have a tool to
                            help curve in a positive way the problematic: reducing EDCs
                            concentration in water and stopping crop contamination but also aiding
                            the economy of the most vulnerable people.Considering the various
                            conditions on which agricultural workers deal with, such as
                            contaminated water or with dangerous compounds, lack of
                            infrastructure, inaccessibility to electricity, far rural areas, among
                            others; it's necessary to be adaptable to all locations, and an easy
                            to use tool.Inside the lab it may be convenient for us to have a
                            sophisticated device in which the laccases will be more functional,
                            but based on the information obtained from farmers, the presentation
                            we give is the way to go.
                            <br/>
                            Keywords reached from stakeholders we are implementing: Economic
                            viability, user-friendly, environmentally friendly and human safe.{" "}
                            <br/>
                            <br/>
                            <h3 className="h3">Ease of use</h3>
                            <br/>
                            In terms of methodology of use it's quite simple; the package with the
                            immobilized laccase and zeolite powder will be opened; and its content
                            will be poured into the water source they will use. After that it will
                            be necessary to just wait for the laccases to do their work,
                            approximately a 48 hour work space.The 48 hour mark is based upon our
                            results of degradation.[Visit Degradation Results to learn more].
                            <br/>
                            It doesn't require any prior knowledge or capacitation to be able to
                            use this powder.
                            <br/>
                            <h3 className="h3">Development</h3>
                            <br/>
                            The use of this technology is very advantageous because it has an
                            increasing rate of development.
                            <br/>
                            The use of zeolite for pollutant removal and water treatment has been
                            on the rise, with nearly 47% of the 9055 total researches published
                            from 2013 to 2021 in the field of removal studies being related to
                            zeolite, and with every passing year these numbers increase further.{" "}
                            <br/>
                            Zeolites by themselves are beneficial for plants having effects of
                            improving photosynthesis because of their capacity to absorb CO2, they
                            also aid in the reduction of transpiration rates which improves the
                            water-use efficiency.[5]
                            <br/>
                            The use of laccase is very common in the degradation of EDCs, but many
                            studies have noticed that the accuracy of using only laccase is very
                            poor and time-consuming, because of that, the decision for combining a
                            modified recombinant laccase and nanotechnology tools, was made by
                            TecCEM.
                            <br/>
                            The development of this technology is rapidly increasing based on the
                            available research and experts.To know this we had a meeting with
                            Engineer Edson Estrada Arriaga, an expert on water treatment with EDCs
                            in Mexico, who pointed out that is a common occurrence of research and
                            development of new technologies to make water drinkable, even by
                            CONAGUA (National Water Commission) and by some enterprises; where
                            this steps help on the long run to solve the problem.
                            <br/>
                            <br/>
                            <h3 className="h3">Limitations</h3>
                            <br/>
                            There is an important factor to improve to give the most efficient use
                            to the product.The velocity of reaction is a property of the laccase
                            that leads to the efficiency of the degradation.With the current
                            product improvements in the time of degradation can be obtained with
                            other cofactors, but more research is needed in that field.Plus, we
                            chose to go for the “easy to use'' factor over “time efficiency”
                            because of the awareness of agriculture's economic position. <br/>
                            <br/>
                            <br/>
                            <h3 className="h3">Further steps</h3>
                            <br/>
                            We are currently trying to delimit in which moment of irrigation to
                            implement our powder with the immobilized laccase.We identify two
                            possibilities: adding the powder onto the main waterbody or pond the
                            farmer uses prior to irrigation, or adding the powder onto the
                            channels where the water flows to flood the plants.
                            <br/>
                            The advantages of adding the powder to the main waterbody or pond is
                            that the immobilized enzyme will have the maximum time to develop any
                            enzymatic activity, but there are some major drawbacks such as: <br/>
                            <br/>
                            - It is unknown for us how the immobilized enzyme will behave on large
                            bodies of water.We don't know if the enzyme will rest at the surface
                            or it will stagnate at the bottom.
                            <br/>
                            <br/>
                            - It is unknown where EDCs rest in stagnant water bodies.We couldn't
                            obtain enough information related to whether EDCs rest at the surface
                            or at the bottom in large water bodies.This is important to know if
                            our immobilized enzyme will be able to interact with EDCs in the same
                            location.A useful study would be to measure the concentration of EDCs
                            in water bodies at different depths to know where they’re more
                            concentrated.
                            <br/>
                            <br/>
                            Regarding the other proposal of adding the powder on the channels,
                            some of the advantages would be the proximity to the plants where is
                            our location of interest for the enzyme to work on.Also the zeolite
                            would have the maximum potential of eliminating other compounds and
                            giving beneficial properties to the plant as explored before.But there
                            are some mechanisms in which we don't have enough information
                            about.With the knowledge that EDCs can seep underground to reach
                            groundwater we can hypothesize that our immobilized enzyme could
                            follow the same route.We can also hypothesize that the humidity of the
                            soil and the constant irrigation (or flooding) could act like
                            resuspending the enzyme to allow it to keep degrading.A useful
                            experiment would be to add EDCs on soil and add the powder with the
                            immobilized enzyme and observe if the constant irrigation like the
                            ones used on irrigation by flooding has any beneficial effect on the
                            enzymatic activity.
                            <br/>
                            To confirm any of these hypotheses is necessary to develop the
                            experimentals and research to make any conclusions.
                            <br/>
                        </p>
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/endpointsinfondo.png"
                            alt="endpointsinfondo"
                            className="figure"
                        />
                        <p className="figure_desc">
                            <strong>Fig. 3 </strong>Possible endpoints to apply degradation system
                        </p>
                        <p className="p"></p>
                        <br/>
                        <br/>
                        <h3 className="h3">Production and delivery</h3>
                        <br/>
                        As a final product, the immobilized enzyme is in powder form, the user
                        will be given an envelope containing the necessary amount of immobilized
                        enzyme to perform the degradation.
                        <br/>
                        The needed amounts for implementation outside the lab couldn't be
                        obtained because our results ended up being inconsistent [Visit
                        Degradation Results to laern more]. Also we couldn't give out an amount of necessary
                        immobilized enzymes because our concentrations obtained from our results
                        were not the most consistent.Also because of time it wasn't possible to
                        develop an essay with the immobilized enzyme with zeolites, so its
                        concentration to degrade on a certain volume of water is unknown, but
                        this would be a great experiment for the future. <br/>
                        But a great aspect is that for seeing results it's not necessary a large
                        scale production to implement the product.The amount of immobilized
                        enzyme for the given volume of water is low.And these quantities are
                        related in a directly proportional way.
                        <br/>
                        The cost-effectiveness for water treatment depends on the price of
                        commercially available products and the nanotechnology tools used for
                        the immobilization.
                        <br/>
                        <br/>
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/cajaimbozeolite.png"
                            alt="cajaimbozeolite"
                            className="figure"
                        />
                        <p className="figure_desc">
                            <strong>Fig. 4 </strong>Powder of immobilized laccase in zeolite
                        </p>
                        <p className="p">
                            <br/>
                            <br/>
                            <h3 className="h3">Dual Use</h3>
                            <br/>
                            Biosecurity and biosafety are our main concerns when working in a lab
                            and taking our work to the real world.
                            <br/>
                            <br/>
                            <strong>1) Biosafety</strong>
                            <br/>
                            In terms of biosafety, no special equipment for safety is necessary
                            inside the lab or during production but the lab coat as in any
                            laboratory.
                            <br/>
                            There are no known side effects or allergic reactions to the use of
                            laccase from Trametes versicolor.
                            <br/>
                            Also no special waste treatments are needed, but waste material must
                            be disposed of in accordance with national protocols.
                            <br/>
                            <br/>
                            <strong>2) Biosecurity</strong>
                            <br/>
                            With biosecurity related; any misuse or intentional release wouldn't
                            cause any harm to the environment, users, crops or water.
                            <br/>
                            The laccase used is recombinantly synthesized using E.coli DH5A BL21
                            and HMS 174 strains.Therefore, ingestion by humans could cause stomach
                            upset.However, apart from ingestion or contact with the nose or eyes,
                            it is a safe product for humans and other living organisms. As well,
                            the zeolite wouldn't cause any harm as there are established methods
                            for wastewater treatment with zeolite, which removes heavy metals from
                            the water, and a wide variety of toxic compounds.It can also be added
                            that zeolite doesn't break down over time but improves nutrient
                            retention, significantly reducing water and fertilizer costs by
                            retaining nutrients in the root zone.[6]
                            <br/>
                            <br/>● Mutations with the laccase can be ruled out considering that
                            the enzyme is already immobilized.
                            <br/>
                            <br/>● Autonomous release can also be ruled out because the proteins
                            are unable to spread.Although as we presented in our results and
                            research, the immobilized enzyme can be washed with the water current;
                            but the free enzyme being washed around the soil wouldnt represent any
                            risk to the environment.
                            <br/>
                            <br/>● The thing that can happen to the enzyme is denaturalization
                            because of pH; where the ideal pH for our laccase is from 4.5 to 8.
                            The enzyme is not functional under extreme conditions.The pH range
                            where the laccase is functional is also correlated to the pH
                            conditions present on untreated water.
                            <br/>
                            <br/>
                            No options for preventing or stopping attacks related to an
                            intentional harmful use of the product is needed, because by its own
                            means it can’t cause any harm.
                            <br/>
                            <br/>
                            <h3 className="h3">References:</h3>
                            <br/>
                            <br/>
                            [1]SEMARNAT.(2019).Porcentaje de unidades de producción con superficie
                            de riego según sistema de irrigación utilizado.
                            http://dgeiawf.semarnat.gob.mx:8080/ibi_apps/WFServlet?IBIF_ex=D2_AGRIGAN01_35&IBIC_user=dgeia_mce&IBIC_pass=dgeia_mce&NOMBREENTIDAD=*
                            <br/>
                            <br/>
                            [2]En la agricultura, los sistemas de riego son utilizados para un
                            aprovechamiento óptimo del agua.(2018).Servicio de Información
                            Agroalimentaria y Pesquera.
                            https://www.gob.mx/siap/articulos/en-la-agricultura-los-sistemas-de-riego-son-utilizados-para-un-aprovechamiento-optimo-del-agua?idiom=es
                            <br/>
                            <br/>
                            [3]Gustavo Ronderos-Lara, J., Saldarriaga-Noreña, H., Guillermo
                            Reyes-Romero, P., Alberto Chávez-Almazán, L., Vergara-Sánchez, J.,
                            Alfonso Murillo-Tovar, M., & Torres-Segundo, C.(2021).Emerging
                            Compounds in Mexico: Challenges for their identification and
                            elimination in wastewater.In Emerging Contaminants.IntechOpen.
                            <br/>
                            <br/>
                            [4]CONEVAL.(2020).Medición de pobreza 2016-2020. Coneval.org.mx.
                            Retrieved 6 September 2022, from
                            https://www.coneval.org.mx/Medicion/MP/Paginas/Pobreza_2020.aspx.
                            <br/>
                            <br/>
                            [5]De Smedt, C., Steppe, K., & Spanoghe, P.(2017).Beneficial effects
                            of zeolites on plant photosynthesis.Advanced Material Science, 2(1).
                            https://doi.org/10.15761/ams.1000115
                            <br/>
                            <br/>
                            [6]Szatanik-Kloc, A., Szerement, J., Adamczuk, A., & Józefaciuk, G.
                            (2021).Effect of low zeolite doses on plants and soil physicochemical
                            properties.Materials, 14(10), 2617. https://doi.org/10.3390/ma14102617
                            <br/>
                            <br/>
                            <br/>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}